<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localvisible"
      width="70%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="formData" label-width="100px">

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="手机号">
              <el-input width="400" placeholder="请输入手机号"  v-model="mobile" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="选择套餐" >
              <el-radio-group v-model="group_id"  @change="handleChange">
                <el-radio :label="1">A套餐</el-radio>
                <el-radio :label="2">B套餐</el-radio>
                <el-radio :label="3">C套餐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item>
              <el-table
                ref="multipleTable"
                :data="mList"
                stripe
                border
              >
                <el-table-column
                  label="产品名称"
                  width="115"
                  :show-overflow-tooltip='true'
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.goods.goods_name ||'' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="门店名称"
                  width="115"
                  :show-overflow-tooltip='true'
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.shop.shop_name ||'' }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="日期">
              <el-date-picker width="400" clearable type="date"  v-model="order_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import axios from "axios";
  import moment from 'moment'     //日期时间转换
  export default {
    name:'eAddOrder',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default:null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data() {
      return {
        localvisible:false,
        group_id:1,
        order_time:'',
        categoryList:[],

        memberLoading:'',
        memberList:[],
        memberStates:[],

        lng_lat:'',

        areaList: [],

        rules: {

        },
        curShop: '',
        employee_id: '',
        name_cn: '',
        mobile:'',
        keywords: '',
        fileList: [],
        mList: [],
        pageNum: 1,
        pageSize: 10,
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          lazy: true,
          lazyLoad(node, resolve) {
            // const {level} = node;
            console.log(node)
            let url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份


                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: 1
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                });
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
      this.getList();
      this.order_time=moment().format('YYYY-MM-DD');
      //this.getCategoryList();
    },
    methods:{
      handleChange(e){
        this.group_id=e;
        this.total=[];
        this.mList=[];
        this.getList();
      },
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.formData.province_id=checkedNode[0].path[0];
        _this.formData.city_id=checkedNode[0].path[1];
        _this.formData.district_id=checkedNode[0].path[2];
      },
      // 关闭
      handleClose() {
        //this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let params=this.formData;
        params.goodsList=this.mList;
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');
        this.$axios.yhOrderSave(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");
            this.handleClose();
            return;
          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },
      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          group_id:this.group_id
        }
        this.$axios.yhGoodsGroupListP(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      },
      getCategoryList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"AccountCategory",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.categoryList =res.data;

          }
        }).catch(error=>{
          console.log(error);
        })
      },
      memberRemoteMethod(query){
        if (query !== '') {
          this.memberLoading = true;
          let param={
            keyword:query,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.posMemberListP(param).then(res=>{
            if(res.code == 200){
              this.memberStates = res.data.data;
            }
          }).catch(error=>{
              console.log(error);
          })
          setTimeout(() => {
            this.memberLoading = false;
            this.memberList = this.memberSet.filter(item => { // 这里的this.list，换为this.applicantSet
              return item.name;
            });
          }, 1000);
        } else {
          this.memberList = [];
        }
      },
    },
    computed: {
      memberSet() {
        return this.memberStates.map(item => {
          return {id: `${item.id}`, name: `${item.merchant_name}`};
        });
      },
    },
    // 监听
    watch: {
     async visible(val) {

        console.log('----val----',val)
        if (val) {
         if(this.formData.member){
           console.log('----merchant----',this.formData.member.merchant_name)
           await this.memberRemoteMethod(this.formData.member.merchant_name);
        //   this.formData.pos_member_id=this.formData.member.id+'';
           console.log('----id----',this.formData.member.id)

          this.$refs['cascaderAddr'].inputValue=(this.formData.province?this.formData.province.region_name:'')+'-'+(this.formData.city?this.formData.city.region_name:'')+'-'+(this.formData.district?this.formData.district.region_name:'');



         }
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
